import { Checkbox, Col, Row } from 'antd';
import * as _ from 'lodash';
import moment from 'moment';
import React, {
  MutableRefObject,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled, { CSSProperties } from 'styled-components';
import styles from './styles.module.css';

import { ReactComponent as PaymentIcon } from 'app/assets/img/payment_icon.svg';
import { ReactComponent as TicketFormIcon } from 'app/assets/img/ticket-form.svg';
import PartnerModal from 'app/components/PartnerModal';
import StyledButton from 'app/components/StyledButton';
import { DESKTOP_WIDTH } from 'app/hooks/useWindowSize';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { useCheckCartConfig } from 'app/pages/Checkout/hooks/useCheckCartConfig';
import {
  GET_LIST_PAYMENT_METHOD,
  useCheckoutSlice,
} from 'app/pages/Checkout/slice';
import { selectListPaymentMethod } from 'app/pages/Checkout/slice/selectors';
import { TDataTemp } from 'app/pages/UnionRepresentative/types';
import { notify } from 'reapop';
import { BP_TYPE, MAP_VGS, TICKET_TYPES } from 'utils/constants';
import { formatNumber } from 'utils/helper';
import { setOrderItems } from 'utils/orderRequestId';
import { UTC_OFFSET } from 'utils/hooks/useCountDown';
import { FormCustomContext } from '../..';
import { I_TicketDataToGetPrice } from '../../hooks/useCartNew';
import { generateTicketIdentify, generateTicketInfo } from '../../utils';
import { I_CartItem } from '../../slice/types';
import { CART_ERROR_TYPE } from '../TicketItem';
import checkHaveTicketOnSelectedDate from '../TicketItem/partials/helper';
import { RootState } from 'types';

interface PaymentInfoProps {
  allocatedDebt: number | null;
  deliverTicketTypeList: Record<string, any>;
  isCreatingOrderInProxyBuyerFlow: MutableRefObject<boolean>;
  disableCreateOrder: boolean;
}

const PaymentInfo = (props: PaymentInfoProps) => {
  const {
    allocatedDebt,
    deliverTicketTypeList,
    isCreatingOrderInProxyBuyerFlow,
    disableCreateOrder,
  } = props;

  const {
    totalAmountSelected,
    totalPriceSelected,
    onGoToCatologPage,
    listCart,
    ticketsSortedByPark,
    onSetCart,
    paymentMethod,
    setPaymentMethod,
    onChangePaymentMethod,
    deliverTicketType,
    setDeliverTicketType,
    onGetTicketPrice,
  } = useContext(FormCustomContext);
  const dispatch = useDispatch();
  useCheckoutSlice();
  const { checkConfig } = useCheckCartConfig();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const listPaymentMethod = useSelector(selectListPaymentMethod);
  const isLoadingCart = useSelector((state: RootState) => state.cart?.loading);
  const userInfo = useSelector(selectInfoUser);
  const isProxyBuyer =
    (userInfo?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  // Mua hộ mới
  const [openBpAllocatedModal, setOpenBpAllocatedModal] = useState(false);
  const [isCreatingOrderProxyBuyerFlow, setIsCreatingOrderBuyerFlow] =
    useState(false);
  const handleBuyTicketProxyBuyerFlow = async (
    bpAllocatedDebt: string | number,
  ) => {
    const selectedTickets = listCart.filter(item => !!item?.selected);

    const dataToGetPrice: I_TicketDataToGetPrice[] = selectedTickets.map(i => ({
      show_id: i?.show?.id,
      used_area2: i?.usedArea2,
      date: i?.date,
      zone_id: i?.zone?.id,
      amount: i?.amount?.toString() ?? '',
      restaurant_id: i?.restaurant?.id,
      bpAllocatedDebt,
      ...(i?.product?.isLongTerm ? { isLongTerm: '1' } : {}),
    }));

    const onSuccess = (response, currentCartData) => {
      const responseAsObject: Record<string, Record<string, any>> = {};
      const errorResponseAsObject: Record<string, Record<string, any>> = {};
      setIsCreatingOrderBuyerFlow(false);
      isCreatingOrderInProxyBuyerFlow.current = false;
      let isHasError = false;

      response?.forEach(item => {
        const identify = generateTicketIdentify({
          showId: item?.show_id,
          performanceId: undefined,
          zoneId: item?.zone_id,
          date: item?.date,
          restaurantId: item?.restaurant?.id ?? item?.restaurant_id,
          usedArea2: item?.used_area2,
        });
        responseAsObject[identify] = item;

        const itemInCart = currentCartData?.find(i => i?.identify === identify);

        const isErrorSAP = !!(item?.error?.errorSap ?? item?.errorSap);
        const errMsg =
          item?.error?.message ?? item?.errorTicket ?? item?.errorTime;

        if (!errMsg) return;

        isHasError = true;

        const ticketInfo = generateTicketInfo(
          itemInCart?.show?.name,
          moment(item?.date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          item?.restaurant?.name,
          item?.usedArea2Object?.label,
        );
        dispatch(
          notify(`${ticketInfo}: ${errMsg}`, 'error', {
            title: 'Oops',
            dismissAfter: 15e3,
          }),
        );
        if (!isErrorSAP) errorResponseAsObject[identify] = item;
      });

      onSetCart(
        currentCartData?.map(ticket => {
          const ticketResponseData = errorResponseAsObject?.[ticket?.identify];
          if (ticketResponseData) {
            const err = ticketResponseData?.error;
            if (err?.action === 'popup') {
              onOpenDialogNoti({
                type: 'ERROR',
                isShow: true,
                title: '',
                content: err?.message,
                maskClosable: false,
                onCloseDialog() {
                  onCloseDialogNoti();
                },
              });
            }
            return {
              ...ticket,
              jumpTicket: err?.jumpTicket || ticket?.show?.jumpValueB2b,
              minAmountTicket: err?.minAmount || ticket?.show?.minAmountB2b,
              ...(err?.action !== 'popup' && {
                errorTime:
                  ticketResponseData?.errorTime ??
                  (err?.errorType === CART_ERROR_TYPE.ERROR_TIME
                    ? err?.message
                    : ''),
                errorTicket:
                  ticketResponseData?.errorTicket ??
                  ([
                    CART_ERROR_TYPE.ERROR_TICKET,
                    CART_ERROR_TYPE.JUMP_TICKET,
                    CART_ERROR_TYPE.MIN_TICKET,
                  ].some(item => item === err?.errorType)
                    ? err?.message
                    : ''),
              }),
            };
          }
          return { ...ticket };
        }),
      );

      if (isHasError) return;

      //
      const dataTemp: TDataTemp[] = selectedTickets.map(ticket => ({
        show_id: ticket?.show?.id,
        amount: ticket.amount,
        used_area2: ticket?.usedArea2 ?? 'undefined',
        date: ticket?.date,
        zone_id: ticket?.zone?.id,
        restaurant_id: ticket?.restaurant?.id,
        deliver_ticket_id: deliverTicketType?.toString() ?? '',
        payment: paymentMethod?.toString() ?? '',
        allocatedDebt: bpAllocatedDebt ? +bpAllocatedDebt : undefined,
      }));

      const newListCart: any = [];
      ticketsSortedByPark.forEach(item => {
        item.tickets.forEach(element => {
          if (element?.selected) {
            const priceData = responseAsObject[element?.identify ?? ''];
            newListCart.push({
              ...element,
              price: priceData?.price ?? element?.price,
              originalPrice: priceData?.originalPrice ?? element?.originalPrice,
              park: item.park,
            });
          }
        });
      });

      setOrderItems(newListCart);

      sessionStorage.setItem('dataTemp', JSON.stringify(dataTemp));
      history.push('/union-representative');
    };

    isCreatingOrderInProxyBuyerFlow.current = true;
    setIsCreatingOrderBuyerFlow(true);
    onGetTicketPrice(
      dataToGetPrice,
      paymentMethod?.toString() ?? '',
      onSuccess,
      error => {
        setIsCreatingOrderBuyerFlow(false);
        onError(error);
      },
      undefined,
      true,
    );
  };

  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();

  const { isLoading, setIsLoading, setIsSubmitted } =
    useContext(FormCustomContext);

  const isSelectAnyItem = listCart.some(i => i.selected);

  const history = useHistory();

  const translations = useSelector(selectTranslations);

  useEffect(() => {
    dispatch(
      GET_LIST_PAYMENT_METHOD({
        ticketType: sessionStorage.getItem('ticketType'),
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (listPaymentMethod.length > 0) {
      setPaymentMethod(
        listPaymentMethod?.find(i => i.default === true)?.id ??
        listPaymentMethod?.[0]?.id,
      );
    }
  }, [listPaymentMethod, setPaymentMethod]);

  const onCreateOrder = useCallback(
    async (cartDataOverride?: I_CartItem[]) => {
      const cartData = cartDataOverride ?? listCart;

      if (isLoading || !isSelectAnyItem) return false;
      setIsLoading(true);
      setIsSubmitted(true);
      if (!executeRecaptcha) return;
      const tokenCaptcha = await executeRecaptcha('createOrder');
      const formData = new FormData();
      formData.append('captcha', tokenCaptcha);
      formData.append('payment_method', paymentMethod?.toString() ?? '');
      formData.append('deliver_ticket_id', deliverTicketType?.toString() ?? '');

      let isHasErrorData = false;
      let listCartClone = JSON.parse(JSON.stringify(cartData));
      let firstErrorId: string = '';

      const ticketsSelected = cartData.filter(item => item?.selected);
      const dataTemp: TDataTemp[] = [];

      ticketsSelected.forEach(ticket => {
        const isNotApplyUsedArea2 =
          ticket?.show?.materialType === TICKET_TYPES.CABLE_CAR;
        const isNotApplyZone =
          ticket?.show?.materialType === TICKET_TYPES.CABLE_CAR ||
          _.isNil(ticket?.zone) ||
          _.isEmpty(ticket?.zone);
        const isRestaurantTicket =
          ticket.show?.restaurants &&
          ticket.show?.restaurants?.length > 0 &&
          ticket?.show?.materialType !== TICKET_TYPES.CABLE_CAR;

        const isComboDifTicket =
          ticket.catalog?.mapVGS === MAP_VGS.COMBO &&
          ticket.product?.park?.workstationId === 'DIF';

        const isHaveTicketOnSelectedDate = checkHaveTicketOnSelectedDate({
          selectedDate: moment(ticket.date, 'YYYY-MM-DD'),
          dateFrom: moment(ticket.show?.dateFrom?.dateOrigin, 'YYYY-MM-DD'),
          dateTo: moment(ticket.show?.dateTo?.dateOrigin, 'YYYY-MM-DD'),
          isComboDifTicket,
          weekend: ticket.show?.weekend,
          fireworkDay: ticket.show?.fireworkDay,
        });

        if (
          !isHaveTicketOnSelectedDate ||
          ticket?.errorTicket ||
          ticket?.errorTime ||
          !+((isProxyBuyer ? Infinity : ticket?.inventory) ?? 0) ||
          (!ticket?.zone?.id && !isNotApplyZone) ||
          (!ticket?.usedArea2 && !isNotApplyUsedArea2) ||
          ((ticket?.usedAreas2 ?? [])?.length < 1 && !isNotApplyUsedArea2) ||
          (isRestaurantTicket && !ticket?.restaurant?.id)
        ) {
          isHasErrorData = true;
          if (!firstErrorId) firstErrorId = ticket.identify!;
        }

        if (!+ticket.amount) {
          isHasErrorData = true;
          if (!firstErrorId) firstErrorId = ticket.identify!;
          listCartClone = listCartClone.map(i => {
            if (i.identify !== ticket.identify) return i;
            return {
              ...i,
              errorTicket: translations?.['b2b.txt.plsChooseTicket'] ?? '',
            };
          });
        }

        // Thêm thông tin vào đối tượng kết quả
        dataTemp.push({
          show_id: ticket?.show?.id,
          amount: ticket.amount,
          used_area2: ticket?.usedArea2 ?? 'undefined',
          date: ticket?.date,
          zone_id: ticket?.zone?.id,
          restaurant_id: ticket?.restaurant?.id,
          deliver_ticket_id: deliverTicketType?.toString() ?? '',
          payment: paymentMethod?.toString() ?? '',
          allocatedDebt,
        });
      });
      const newListCart: any = [];

      if (isHasErrorData) {
        onSetCart(listCartClone);
        const y =
          (document.getElementById(firstErrorId)?.getBoundingClientRect()
            ?.top ?? 0) +
          window.pageYOffset -
          160;
        window.scrollTo({ top: y, behavior: 'smooth' });
        setIsLoading(false);

        return false;
      }

      if (formData.entries().next().done) {
        return false;
      }

      ticketsSelected.forEach(ticket => {
        newListCart.push({ ...ticket, park: ticket?.show?.park });
      });

      setOrderItems(newListCart);

      sessionStorage.setItem('dataTemp', JSON.stringify(dataTemp));
      history.push('/union-representative');
    },
    [
      deliverTicketType,
      executeRecaptcha,
      history,
      isLoading,
      isSelectAnyItem,
      listCart,
      onSetCart,
      paymentMethod,
      setIsLoading,
      setIsSubmitted,
      translations,
      allocatedDebt,
      isProxyBuyer,
    ],
  );

  const handleChangePaymentMethod = e => {
    const value = e.target.value;
    const payment = listPaymentMethod.find(val => val.id == e.target.value);

    const hourFrom = listPaymentMethod?.find(
      val => val.id == e.target.value,
    )?.validFrom;
    const hourTo = listPaymentMethod?.find(
      val => val.id == e.target.value,
    )?.validTo;

    if (hourFrom && hourTo) {
      const parseHourFrom = moment(hourFrom, 'HH:mm').format('HH');
      const parseHourTo = moment(hourTo, 'HH:mm').format('HH');
      const parseMinuteFrom = moment(hourFrom, 'HH:mm').format('mm');
      const parseMinuteTo = moment(hourTo, 'HH:mm').format('mm');
      const currentDate = moment().utcOffset(UTC_OFFSET);
      const currentHour = currentDate.hours() + currentDate.minutes() / 60;
      const isValidHour =
        currentHour >=
        parseInt(parseHourFrom, 10) + parseInt(parseMinuteFrom, 10) / 60 &&
        currentHour <
        parseInt(parseHourTo, 10) + parseInt(parseMinuteTo, 10) / 60;
      if (!isValidHour) {
        onOpenDialogNoti({
          type: 'ERROR',
          title: '',
          content: translations?.['b2b.txt.payment_notice_2']?.replace(
            '${payment}',
            payment?.name,
          ),
          isShow: true,
          buttons: [],
          maskClosable: false,
          closable: true,
          onCloseDialog: onCloseDialogNoti,
        });
        return;
      }
    }
    onChangePaymentMethod(value);
    setPaymentMethod(value);
  };

  const handleChangeDeliverTicketType = e => {
    const value = e.target.value;
    setDeliverTicketType(value);
  };

  const onError = (error: any) => {
    if (error?.action === 'popup') {
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        content: error?.message,
        maskClosable: false,
        onCloseDialog() {
          onCloseDialogNoti();
        },
      });
    } else {
      const errMsg = error?.message;
      dispatch(
        notify(errMsg, 'error', {
          title: 'Oops',
          dismissAfter: 5000,
        }),
      );
    }
  };

  const { partner } = useContext(FormCustomContext);

  const infoUser = useSelector(selectInfoUser);
  const isShowTag = useMemo(() => {
    if (!!partner) {
      return !!partner?.bpLongTerm && !!partner?.allowBuyShortTerm;
    }
    return (
      !!infoUser?.businessPartner?.bpLongTerm &&
      !!infoUser?.businessPartner?.allowBuyShortTerm
    );
  }, [infoUser, partner]);

  const validateSelectedTicket = () => {
    let isHasErrorData = false;
    let listCartClone = JSON.parse(JSON.stringify(listCart));
    let firstErrorId: string = '';

    const selectedTickets = listCart.filter(item => !!item?.selected);

    selectedTickets.forEach(ticket => {
      const isNotApplyUsedArea2 =
        ticket?.show?.materialType === TICKET_TYPES.CABLE_CAR;
      const isNotApplyZone =
        ticket?.show?.materialType === TICKET_TYPES.CABLE_CAR ||
        _.isNil(ticket?.zone) ||
        _.isEmpty(ticket?.zone);
      const isRestaurantTicket =
        ticket.show?.restaurants &&
        ticket.show?.restaurants?.length > 0 &&
        ticket?.show?.materialType !== TICKET_TYPES.CABLE_CAR;

      const isComboDifTicket =
        ticket.catalog?.mapVGS === MAP_VGS.COMBO &&
        ticket.product?.park?.workstationId === 'DIF';

      const isHaveTicketOnSelectedDate = checkHaveTicketOnSelectedDate({
        selectedDate: moment(ticket.date, 'YYYY-MM-DD'),
        dateFrom: moment(ticket.show?.dateFrom?.dateOrigin, 'YYYY-MM-DD'),
        dateTo: moment(ticket.show?.dateTo?.dateOrigin, 'YYYY-MM-DD'),
        isComboDifTicket,
        weekend: ticket.show?.weekend,
        fireworkDay: ticket.show?.fireworkDay,
      });

      if (
        !isHaveTicketOnSelectedDate ||
        ticket?.errorTicket ||
        ticket?.errorTime ||
        !+((isProxyBuyer ? Infinity : ticket?.inventory) ?? 0) ||
        (!ticket?.zone?.id && !isNotApplyZone) ||
        (!ticket?.usedArea2 && !isNotApplyUsedArea2) ||
        ((ticket?.usedAreas2 ?? [])?.length < 1 && !isNotApplyUsedArea2) ||
        (isRestaurantTicket && !ticket?.restaurant?.id)
      ) {
        isHasErrorData = true;
        if (!firstErrorId) firstErrorId = ticket.identify!;
      }

      if (!+ticket.amount) {
        isHasErrorData = true;
        if (!firstErrorId) firstErrorId = ticket.identify!;
        listCartClone = listCartClone.map(i => {
          if (i.identify !== ticket.identify) return i;
          return {
            ...i,
            errorTicket: translations?.['b2b.txt.plsChooseTicket'] ?? '',
          };
        });
      }
    });

    if (isHasErrorData) {
      onSetCart(listCartClone);
      const y =
        (document.getElementById(firstErrorId)?.getBoundingClientRect()?.top ??
          0) +
        window.pageYOffset -
        160;
      window.scrollTo({ top: y, behavior: 'smooth' });
      return;
    }

    return true;
  };

  const validateTicketProxyBuyer = () => {
    if (!validateSelectedTicket()) return;
    setOpenBpAllocatedModal(true);
  };

  const handleSubmitCart = async () => {
    if (isLoading || !isSelectAnyItem || disableCreateOrder || isLoadingCart) {
      return;
    }

    const uniqueElements = new Set(
      listCart
        .filter(ele => !!ele?.selected)
        .map(item => item?.product?.isLongTerm),
    );
    if (!validateSelectedTicket()) return;
    const paramCheckConfig = listCart
      .filter(item => !!item?.selected)
      .map(i => ({
        ticket_id: i?.product?.id,
        date: i?.date,
        quantity: i?.amount?.toString() ?? '',
        ticketType: sessionStorage.getItem('ticketType') || '',
      }));
    const resCheckConfig = await checkConfig(paramCheckConfig, {
      onStart: () => {
        setIsLoading(true);
        setIsSubmitted(true);
      },
      onFinish: () => {
        setIsLoading(false);
        setIsSubmitted(false);
      },
      onError: (error, source) => {
        if (source === 'exception') return;
        onSetCart(
          listCart.map(ticket => {
            const err = error?.tickets?.find(
              t =>
                String(t.ticket_id) === String(ticket?.product?.id) &&
                String(t.date) === String(ticket?.date),
            )?.message;
            if (!!err) {
              return {
                ...ticket,
                jumpTicket: err?.jumpTicket || ticket?.show?.jumpValueB2b,
                minAmountTicket: err?.minAmount || ticket?.show?.minAmountB2b,
                errorTime:
                  err ??
                  (err?.errorType === CART_ERROR_TYPE.ERROR_TIME
                    ? err?.message
                    : ''),
              };
            }
            return { ...ticket };
          }),
        );
      },
    });
    if (!resCheckConfig.ok) return;
    if (isProxyBuyer) {
      validateTicketProxyBuyer();
      return;
    }

    if (isShowTag && uniqueElements.size > 1) {
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        content: translations?.['b2b.txt.ticket-filter-instruction'],
        maskClosable: false,
        onCloseDialog() {
          onCloseDialogNoti();
        },
      });
      return;
    }
    const dataToGetPrice: I_TicketDataToGetPrice[] = listCart
      .filter(item => !!item?.selected)
      .map(i => ({
        show_id: i?.show?.id,
        // performance: i?.performance?.id,
        used_area2: i?.usedArea2,
        date: i?.date,
        zone_id: i?.zone?.id,
        amount: i?.amount?.toString() ?? '',
        restaurant_id: i?.restaurant?.id,
        bpAllocatedDebt: allocatedDebt,
        ...(i?.product?.isLongTerm ? { isLongTerm: '1' } : {}),
      }));
    const onSuccess = (response, currentCartData) => {
      const responseAsObject: Record<string, Record<string, any>> = {};

      response?.forEach(item => {
        const identify = generateTicketIdentify({
          showId: item?.show_id,
          performanceId: undefined,
          zoneId: item?.zone_id,
          date: item?.date,
          restaurantId: item?.restaurant?.id ?? item?.restaurant_id,
          usedArea2: item?.used_area2,
        });
        responseAsObject[identify] = item;
      });

      let isHasErrorData = false;
      let firstErrorId: string = '';

      let isPriceChanged = false;

      const updatedCartData = (currentCartData ?? []).map(ticket => {
        const ticketResponseData = responseAsObject?.[ticket?.identify];
        if (ticketResponseData) {
          const newInventory = +(ticketResponseData?.inventory ?? 0);
          const err = ticketResponseData?.error;
          const nextOriginalPrice = Number(ticketResponseData?.originalPrice);
          const currentOriginalPrice = Number(ticket?.originalPrice);

          if (!!err) {
            isHasErrorData = true;
            if (!firstErrorId) firstErrorId = ticket?.identify;
          }

          if (
            ticket?.selected &&
            !Number.isNaN(nextOriginalPrice) &&
            !Number.isNaN(currentOriginalPrice) &&
            nextOriginalPrice !== currentOriginalPrice
          ) {
            isPriceChanged = true;
          }

          if (err?.action === 'popup') {
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: err?.message,
              maskClosable: false,
              onCloseDialog() {
                onCloseDialogNoti();
              },
            });
          }

          return {
            ...ticket,
            jumpTicket: err?.jumpTicket || ticket?.show?.jumpValueB2b,
            minAmountTicket: err?.minAmount || ticket?.show?.minAmountB2b,
            inventory: newInventory,
            price: ticketResponseData?.price,
            originalPrice: ticketResponseData?.originalPrice,
            // selected: !!+newInventory ? ticket?.selected : false,
            ...(err?.action !== 'popup' && {
              errorTime:
                ticketResponseData?.errorTime ??
                (err?.errorType === CART_ERROR_TYPE.ERROR_TIME
                  ? err?.message
                  : ''),
              errorTicket:
                ticketResponseData?.errorTicket ??
                ([
                  CART_ERROR_TYPE.ERROR_TICKET,
                  CART_ERROR_TYPE.JUMP_TICKET,
                  CART_ERROR_TYPE.MIN_TICKET,
                ].some(item => item === err?.errorType)
                  ? err?.message
                  : ''),
            }),
          };
        }
        return { ...ticket };
      });

      onSetCart(updatedCartData);

      if (isHasErrorData) {
        const y =
          (document.getElementById(firstErrorId)?.getBoundingClientRect()
            ?.top ?? 0) +
          window.pageYOffset -
          160;
        window.scrollTo({ top: y, behavior: 'smooth' });
        return;
      }

      if (response?.some(item => !!item?.error)) {
        return;
      }

      if (isPriceChanged) {
        onOpenDialogNoti({
          type: 'ERROR',
          isShow: true,
          title:
            translations?.['b2b.txt.price-change-title'] ??
            'THAY ĐỔI THÔNG TIN GIÁ',
          content: (
            <PriceChangeConfirmContent>
              {translations?.['b2b.txt.price-change-message'] ??
                'Giá sản phẩm có sự thay đổi so với giỏ hàng. Bạn có muốn tiếp tục không?'}
            </PriceChangeConfirmContent>
          ),
          hideIcon: true,
          maxWidth: 432,
          buttons: [
            {
              text: translations?.['b2b.btn.back'] ?? 'Quay lại',
              bg: '#ffff',
              border: 'solid 1px #BDBDBD',
              color: '#808080',
              onClick: () => {
                onCloseDialogNoti();
              },
            },
            {
              text: translations?.['b2b.btn.continue'] ?? 'Tiếp tục',
              bg: '#F5821F',
              color: 'white',
              onClick: () => {
                onCloseDialogNoti();
                onCreateOrder(updatedCartData);
              },
            },
          ],
          maskClosable: false,
          closable: false,
        });
        return;
      }

      onCreateOrder(updatedCartData);
    };
    onGetTicketPrice(
      dataToGetPrice,
      paymentMethod?.toString() ?? '',
      onSuccess,
      onError,
      undefined,
      true,
    );
  };
  const PaymentNoticeTradeDiscount = () => {
    const paymentNotice = useMemo(() => {
      const detail = listPaymentMethod?.find(val => val.id === paymentMethod);
      const commission = detail?.commission;
      if (!commission || isProxyBuyer) return '';
      const formattedAmount = `${formatNumber(
        detail.code === 'CommissionMou'
          ? commission?.availableAmount || 0
          : commission?.availableAmount || 0,
      ).replaceAll(',', '.')}đ`;
      const formattedDate = commission?.validTo
        ? moment(commission.validTo.toString(), 'YYYYMMDD').format('DD/MM/YYYY')
        : '';
      return (
        translations?.[
          detail.code === 'CommissionMou'
            ? 'b2b.txt.payment_notice_trade_discount'
            : 'b2b.txt.payment_notice_trade_discount'
        ]
          ?.replace('${X}', formattedAmount)
          ?.replace('${end_date}', formattedDate) || ''
      );
    }, [paymentMethod]);
    if (!paymentNotice) return null;
    return (
      <i style={{ fontSize: 14, color: '#000000', marginTop: 8 }}>
        {paymentNotice}
      </i>
    );
  };
  return (
    <Container>
      {listPaymentMethod?.length > 0 && (
        <PaymentMethodComponent>
          <div className="title d-flex align-items-center">
            <PaymentIcon />
            <h3>{translations?.['b2b.table.payment'] ?? ''}</h3>
          </div>
          <div className={styles.checkboxContainer}>
            {listPaymentMethod.map(i => {
              const value = i?.id;
              return (
                <StyledCheckbox
                  key={value}
                  checked={value === paymentMethod}
                  value={value}
                  onChange={handleChangePaymentMethod}
                >
                  <span style={{ textTransform: 'uppercase' }}>
                    {i?.name || i?.code}
                  </span>
                </StyledCheckbox>
              );
            })}
            {listPaymentMethod?.find(val => val.id == paymentMethod)
              ?.validFrom && (
                <i style={{ fontSize: 14, color: '#000000', marginTop: 8 }}>
                  {`${translations
                      ? translations['b2b.txt.payment_notice_1']
                        ?.replace(
                          '${payment}',
                          listPaymentMethod?.find(
                            val => val.id == paymentMethod,
                          )?.name,
                        )
                        ?.replace(
                          '${hour_from}',
                          listPaymentMethod?.find(
                            val => val.id == paymentMethod,
                          )?.validFrom,
                        )
                        ?.replace(
                          '${hour_to}',
                          listPaymentMethod?.find(
                            val => val.id == paymentMethod,
                          )?.validTo,
                        )
                      : ''
                    }`}
                </i>
              )}
            <PaymentNoticeTradeDiscount />
          </div>
        </PaymentMethodComponent>
      )}
      {deliverTicketTypeList?.length > 0 && (
        <PaymentMethodComponent>
          <div className="title d-flex align-items-center">
            <TicketFormIcon />
            <h3>{translations?.['b2b.txt.ticket-issuance-form'] ?? ''}</h3>
          </div>
          <div className={styles.checkboxContainer}>
            {deliverTicketTypeList.map(i => {
              const value = i?.id;
              return (
                <StyledCheckbox
                  key={value}
                  checked={value === deliverTicketType}
                  value={value}
                  onChange={handleChangeDeliverTicketType}
                >
                  {i?.name || i?.code}
                </StyledCheckbox>
              );
            })}
          </div>
        </PaymentMethodComponent>
      )}
      <Payment>
        <h3 className="payment-title">
          {translations?.['b2b.txt.info-pay'] ?? ''}
        </h3>
        <div className="payment-content">
          <div
            className={`d-flex align-items-center justify-content-between ${styles.colorBlack} ${styles.fw500} ${styles.fs14}`}
          >
            <p>{translations?.['b2b.txt.numTicketSelected'] ?? ''}</p>
            <p>{`${formatNumber(totalAmountSelected).replaceAll(',', '.')}`}</p>
          </div>
          <div
            className={`${isProxyBuyer ? 'd-none' : 'd-flex'
              } align-items-center justify-content-between ${styles.colorBlack} ${styles.fw500
              } ${styles.fs16}`}
          >
            <p>{translations?.['b2b.txt.total-amount'] ?? ''}</p>
            <p
              className={styles.colorRed}
              style={{ fontWeight: 600 }}
            >{`${formatNumber(totalPriceSelected).replaceAll(',', '.')} đ`}</p>
          </div>
          <p
            className={`${styles.colorRed} ${styles.fw400} ${styles.fs14}`}
            style={{ margin: 0 }}
          >
            (*){' '}
            <span className={`${styles.textItalic} ${styles.colorBlack}`}>
              {translations?.['b2b.txt.pressCreateOrderToShowOffer'] ?? ''}
            </span>
          </p>
        </div>
      </Payment>
      <Actions gutter={16}>
        <Col span={12}>
          <StyledButton
            textColor="#808080"
            border="solid 1px #808080"
            bgColor="#ffffff"
            width="100%"
            onClick={onGoToCatologPage}
          >
            {translations?.['b2b.btn.buyMore'] ?? ''}
          </StyledButton>
        </Col>
        <Col span={12}>
          <StyledButton
            textColor="#ffffff"
            width="100%"
            onClick={() => {
              handleSubmitCart();
            }}
            style={{
              cursor:
                isLoading || !isSelectAnyItem || disableCreateOrder
                  ? 'not-allowed'
                  : 'pointer',
            }}
          >
            {isLoading
              ? 'Loading...'
              : translations?.['b2b.btn.createOrder'] ?? ''}
          </StyledButton>
        </Col>
      </Actions>
      <PartnerModal
        open={openBpAllocatedModal}
        onClose={() => setOpenBpAllocatedModal(false)}
        onChange={() => { }}
        onProceedToBookTicket={handleBuyTicketProxyBuyerFlow}
        loading={isCreatingOrderProxyBuyerFlow}
      />
    </Container>
  );
};

export default PaymentInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 120px;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    position: static;
    margin-top: 32px;
  }
`;

const Payment = styled.div`
  border-radius: 10px;
  background: #fab317;
  padding: 2px;
  h3.payment-title {
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 13px 10px;
    margin: 0;
  }
  .payment-content {
    padding: 24px 16px 31px;
    background: #ffffff;
    border-bottom-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  p {
    margin-bottom: 9px;
  }
`;

const Actions = styled(Row)`
  margin-top: 24px;
`;

const PriceChangeConfirmContent = styled.div`
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
`;

const PaymentMethodComponent = styled.div`
  margin-bottom: 30px;
  h3 {
    margin: 0 0 0 8px;
    font-size: 18px;
    font-weight: 600;
    color: #000000;
  }
`;

export const StyledCheckbox = styled(Checkbox) <{
  antCheckboxWrapperCSS?: CSSProperties;
  antCheckboxInner?: CSSProperties;
}>`
  &.ant-checkbox-wrapper {
    &:not(:first-child) {
      margin-top: 8px;
      margin-left: 0;
    }
    width: max-content;
    .ant-checkbox-inner {
      border-radius: 50%;
      ${props => ({ ...props.antCheckboxInner })}
    }
    .ant-checkbox {
      & + span {
        color: #000000;
      }
    }
    .ant-checkbox-checked {
      &:after {
        border-radius: 50%;
      }
    }
    ${props => ({ ...props.antCheckboxWrapperCSS })}
  }
`;
